<template>
    <tr class="table-item">
      <td>
        <v-checkbox 
                    v-model="isActive"
                    :ripple="false"
                    hide-details
                    ></v-checkbox>
      </td>
  
      <td>
        {{ formattedLoginTypeName }}
      </td>
  
      <td>
        {{ formattedLoginTypeKey }}
      </td>      
    </tr>
  </template>
  
  <script>
  
  export default {
    components: {      
    },
  
    data() {
      return {};
    },
    props: {
      captiveFormItem: {
        type: Object,
        required: true,
      },
      value: {
        type: Array,
      },      
    },    
    computed: {
      formattedLoginTypeKey() {
        let loginTypeKey;
        switch (this.captiveFormItem.type) {
          case "MAC":
            loginTypeKey = this.$t("message.loginPersonalize.message.noForm");
            break;
          case "CPF":
            loginTypeKey = "CPF";
            break;
          case "CELLPHONE":
            loginTypeKey = this.$t('message.loginPersonalize.message.telephone');
            break;
          case "EMAIL":
            loginTypeKey = "E-mail";
            break;
          case "EXTERNAL_SERVICE":
            loginTypeKey = this.$t(
              "message.loginPersonalize.message.externalService"
            );
            break;
          case "VOUCHER":
            loginTypeKey = "Voucher";
            break;
          default:
            break;
        }
        return loginTypeKey;
      },
      formattedLoginTypeName() {
        let loginTypeName;
        switch (this.captiveFormItem.name) {
          case "FACEBOOK":
            loginTypeName = "Facebook";
            break;
          case "TWITTER":
            loginTypeName = "Twitter";
            break;
          case "LINKEDIN":
            loginTypeName = "Linkedin";
            break;
          default:
            loginTypeName = this.captiveFormItem.name;
            break;
        }
        return loginTypeName;
      },
      isActive: {
        get() {
          return this.value.includes(this.captiveFormItem.id)
        },

        set(val) {
          this.emitChange(val)
        }
      },      
    },
    methods: {     
      emitChange(event) {
        const action = event ? "select" : "deselect"
        this.$emit("change", {action, id: this.captiveFormItem.id});
      },           
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .table-item {   
  
    &:last-child {
        margin-right: 0;
    }
      
  }
  </style>
  